import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import InsideHeader from "../../../components/InsideHeader"; 
import {  setFolderObj } from "../../../features/folder/folderSlice";
import DeleteModal from "../../../components/DeleteModal"; 
import TableLoading from "../../../components/TableLoading";  
import AddFixedAssetModal from "./modal/AddFixedAssetModal";
import { fetchFixedAsset } from "../../../features/dropdown/dropdownSlice";
import { deleteFixedAsset } from "../../../features/staff-setting/staffSettingSlice";
import Search from "../../../components/Search";
import { cashConverter } from "../../../utils";

export default function FixedAssetTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fixedAssetsData, loading, fixedAssetsCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
  };

  const filterDataList = searchInput
  ? fixedAssetsData?.filter((item) =>
      item?.faName?.toLowerCase().includes(searchInput.toLowerCase())
    )
  : fixedAssetsData;

  async function handleAdd() {
    await setProdd("");
    await setopen(true);
  }
   

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteFixedAsset({
        faId: prodd?.faId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchFixedAssetData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
 
  const handleEdit = () => {
    setopen(true);
  };

  const handleView = async () => {
    await dispatch(setFolderObj(prodd));
    await navigate("/fixed-assets-details");
  };
  const settingItems = [
    {
      key: "3",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Details
        </Link>
      ),
    },
    
    {
      key: "1",
      label: (
        <Link
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Delete
        </Link>
      ),
    },
  ];

  const columns = [
    {
      title: "Item Name",
      dataIndex: "faName",
      sorter: (a, b) => a.faName.localeCompare(b.faName),
    }, 
    {
      title: "Value",
      dataIndex: "faBookValue",
      sorter: (a, b) => a.faBookValue -b.faBookValue,
    },
    {
      title: "Acquisition Cost",
      dataIndex: "faAcquisitionCost",
      render:(item)=>{
        return(
          <div>{cashConverter(item)}</div>
        )
      },
      sorter: (a, b) => a.faAcquisitionCost -b.faAcquisitionCost,
    },
    {
      title: "Serial Number",
      dataIndex: "faSerialNumber",
      sorter: (a, b) => a.faSerialNumber.localeCompare(b.faSerialNumber),
    }, 
    {
      title: "Description",
      dataIndex: "faDescription",
      sorter: (a, b) => a.faDescription.localeCompare(b.faDescription),
    }, 
    
    {
      title: "Status",
      dataIndex: "faStatus",
      sorter: (a, b) => a.faStatus.localeCompare(b.faStatus),
    }, 

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchFixedAssetData(page, size) {
    dispatch(
      fetchFixedAsset({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchFixedAssetData();
  }, []);

 
  if (loading) return <TableLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Fixed assets Information"
        subtitle="Manage Fixed assetss within your institution"
        back={false}
      />
      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
            Fixed assets Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="w-[16.8125rem] lg:mt-0 mt-3">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search Fixed assets..."}
              />
            </div>

            <div className="w-[250px]">
              <button onClick={() => handleAdd()} className="cstm-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M19.5 11H13.5V5C13.5 4.73478 13.3946 4.48043 13.2071 4.29289C13.0196 4.10536 12.7652 4 12.5 4C12.2348 4 11.9804 4.10536 11.7929 4.29289C11.6054 4.48043 11.5 4.73478 11.5 5V11H5.5C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13H11.5V19C11.5 19.2652 11.6054 19.5196 11.7929 19.7071C11.9804 19.8946 12.2348 20 12.5 20C12.7652 20 13.0196 19.8946 13.2071 19.7071C13.3946 19.5196 13.5 19.2652 13.5 19V13H19.5C19.7652 13 20.0196 12.8946 20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929C20.0196 11.1054 19.7652 11 19.5 11Z"
                    fill="#FFCD47"
                  />
                </svg>
                <span className="ml-1">Add Fixed Asset</span>
              </button>
            </div>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.faId}
                columns={columns}
                dataSource={filterDataList}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: fixedAssetsCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchFixedAssetData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete ${prodd?.faName}?`}
        title={`Delete ${prodd?.faName}`}
      />

      <AddFixedAssetModal
        handleFetchData={fetchFixedAssetData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />
    </div>
  );
}
